// CH TOURS — Full i18n dictionary (PT / EN / ES)
export const translations = {
    pt: {
        nav: {
            home: "Início",
            about: "Sobre",
            tours: "Tours",
            gallery: "Galeria",
            contact: "Contato",
            book: "Reservar",
        },
        hero: {
            title: "CH TOURS",
            subtitle: "Descubra Portugal com conforto, segurança e uma experiência personalizada.",
            cta_whatsapp: "Reservar pelo WhatsApp",
            cta_tours: "Conheça os Tours",
            scroll: "Deslize para baixo",
        },
        trust: {
            private: "Passeios Privados",
            personal: "Atendimento Personalizado",
            driver: "Motorista Experiente",
            comfort: "Conforto",
            safety: "Segurança",
            flexibility: "Flexibilidade",
        },
        about: {
            eyebrow: "Sobre nós",
            title: "Bem-vindo à CH TOURS",
            p1: "Na CH TOURS contamos com vasta experiência no mercado de turismo em Portugal, oferecendo passeios privados pensados para proporcionar conforto, tranquilidade e experiências inesquecíveis.",
            p2: "Cada tour é realizado de acordo com o desejo de cada cliente, respeitando o seu tempo, interesses e preferências.",
            p3: "Nosso objetivo é proporcionar um atendimento personalizado, permitindo que cada visitante conheça Portugal de forma exclusiva, confortável e segura.",
            p4: "Trabalhamos com profissionalismo, pontualidade, qualidade e dedicação para tornar cada passeio uma experiência memorável.",
            stat1: "Anos de experiência",
            stat2: "Passeios realizados",
            stat3: "Idiomas",
        },
        tours: {
            eyebrow: "Nossos Tours",
            title: "Roteiros Exclusivos por Portugal",
            intro: "Cada passeio é totalmente personalizado. Escolha o tour que mais lhe agrada e reserve diretamente pelo WhatsApp.",
            visited: "Locais visitados",
            book: "Reservar pelo WhatsApp",
            items: [
                {
                    name: "Sintra Imperial",
                    tagline: "O Tour Mais Completo",
                    description: "Descubra os monumentos mais emblemáticos de Sintra em um passeio inesquecível, combinando história, arquitetura, natureza e paisagens deslumbrantes.",
                    places: [
                        "Palácio Nacional de Sintra",
                        "Chalet Biester",
                        "Palácio da Pena",
                        "Vale dos Lagos",
                        "Castelo dos Mouros",
                    ],
                },
                {
                    name: "Encantos da Costa de Sintra",
                    tagline: "Onde o oceano encontra as falésias",
                    description: "Conheça duas das paisagens mais bonitas da costa portuguesa, onde o oceano encontra falésias impressionantes e vilas cheias de charme.",
                    places: ["Azenhas do Mar", "Praia das Maçãs"],
                },
                {
                    name: "Cabo da Roca",
                    tagline: "Onde a Terra Termina",
                    description: "Visite o ponto mais ocidental da Europa Continental e admire uma das vistas mais espetaculares sobre o Oceano Atlântico.",
                    places: ["Cabo da Roca"],
                },
                {
                    name: "Cascais Premium Experience",
                    tagline: "Charme costeiro & praias douradas",
                    description: "Descubra o charme de Cascais e percorra uma das estradas costeiras mais bonitas de Portugal, apreciando praias, falésias e paisagens inesquecíveis.",
                    places: [
                        "Cascais Vila",
                        "Boca do Inferno",
                        "Praia do Guincho",
                    ],
                },
                {
                    name: "Fé, Mar e História",
                    tagline: "Espiritualidade e tradição portuguesa",
                    description: "Uma experiência única que reúne espiritualidade, tradição, cultura portuguesa e uma das vilas medievais mais bonitas do país.",
                    places: ["Fátima", "Nazaré", "Óbidos"],
                },
            ],
        },
        info: {
            eyebrow: "Informações Importantes",
            title: "O que está incluído nos passeios",
            body: "Os valores dos nossos tours incluem exclusivamente o transporte e o acompanhamento durante todo o passeio. Os ingressos para monumentos e atrações turísticas não estão incluídos e devem ser adquiridos separadamente pelos clientes.",
            links_title: "Links oficiais para compra de ingressos",
            pena: "Palácio da Pena",
            regaleira: "Quinta da Regaleira",
        },
        gallery: {
            eyebrow: "Galeria",
            title: "Fotografias de uma jornada por Portugal",
            intro: "Momentos reais dos nossos destinos.",
        },
        diff: {
            eyebrow: "Diferenciais",
            title: "Porquê escolher a CH TOURS",
            items: [
                "Vasta experiência no mercado",
                "Passeios privados",
                "Atendimento personalizado",
                "Flexibilidade no roteiro",
                "Veículo confortável",
                "Motorista experiente",
                "Segurança",
                "Pontualidade",
                "Atendimento em português, inglês e espanhol",
            ],
        },
        reviews: {
            eyebrow: "Avaliações",
            title: "O que os nossos clientes dizem",
            intro: "Histórias reais de quem já viveu Portugal connosco.",
            average: "de média",
            total_reviews: "avaliações",
            based_on: "com base em",
            leave: "Deixar uma avaliação",
            share: "Partilhe a sua experiência",
            form_hint: "Partilhe a sua experiência connosco. A sua avaliação irá aparecer no site após envio.",
            name_label: "Nome",
            country_label: "País",
            tour_label: "Tour realizado",
            tour_placeholder: "Selecione o tour (opcional)",
            rating_label: "Avaliação",
            message_label: "Mensagem",
            submit: "Enviar avaliação",
            submitting: "A enviar...",
            success: "Obrigado! A sua avaliação foi publicada.",
            error: "Não foi possível enviar. Tente novamente.",
            close: "Fechar",
            required: "Campo obrigatório",
            no_reviews: "Ainda sem avaliações. Seja o primeiro!",
            select_rating: "Selecione uma avaliação",
        },
        contact: {
            eyebrow: "Contato",
            title: "Vamos planear a sua próxima aventura",
            intro: "Fale connosco diretamente pelo WhatsApp ou envie a sua mensagem — respondemos rapidamente.",
            whatsapp_big: "Falar pelo WhatsApp",
            name: "Nome",
            email: "E-mail",
            phone: "Telefone",
            message: "Mensagem",
            send: "Enviar via WhatsApp",
            email_label: "E-mail",
            address_label: "Endereço",
            address_value: "Rua do Cabeço, nº 7 — Sintra, Portugal",
            form_hint: "Ao enviar, será redirecionado para o WhatsApp com a sua mensagem.",
        },
        footer: {
            tagline: "Passeios Privados em Portugal",
            slogan: "\"Transformamos cada passeio numa experiência única.\"",
            rights: "Todos os direitos reservados.",
            navigation: "Navegação",
            follow: "Redes Sociais",
        },
        misc: {
            back_to_top: "Voltar ao topo",
            whatsapp_float: "Fale connosco",
            language: "Idioma",
        },
    },

    en: {
        nav: {
            home: "Home",
            about: "About",
            tours: "Tours",
            gallery: "Gallery",
            contact: "Contact",
            book: "Book",
        },
        hero: {
            title: "CH TOURS",
            subtitle: "Discover Portugal with comfort, safety and a personalized experience.",
            cta_whatsapp: "Book on WhatsApp",
            cta_tours: "Explore Our Tours",
            scroll: "Scroll down",
        },
        trust: {
            private: "Private Tours",
            personal: "Personalized Service",
            driver: "Experienced Driver",
            comfort: "Comfort",
            safety: "Safety",
            flexibility: "Flexibility",
        },
        about: {
            eyebrow: "About us",
            title: "Welcome to CH TOURS",
            p1: "At CH TOURS we bring vast experience in Portugal's tourism industry, offering private tours designed to deliver comfort, tranquility and unforgettable experiences.",
            p2: "Every tour is tailored to each client's wishes, respecting their time, interests and preferences.",
            p3: "Our goal is to provide a personalized service, allowing every visitor to discover Portugal in an exclusive, comfortable and safe way.",
            p4: "We work with professionalism, punctuality, quality and dedication to make every tour a memorable experience.",
            stat1: "Years of experience",
            stat2: "Tours completed",
            stat3: "Languages",
        },
        tours: {
            eyebrow: "Our Tours",
            title: "Exclusive Itineraries across Portugal",
            intro: "Every tour is fully customized. Choose the one you love and book directly on WhatsApp.",
            visited: "Places visited",
            book: "Book on WhatsApp",
            see_more: "View more photos",
            close: "Close",
            photos_of: "Tour photographs",
            items: [
                {
                    name: "Imperial Sintra",
                    tagline: "The Most Complete Tour",
                    description: "Discover Sintra's most emblematic monuments in an unforgettable journey blending history, architecture, nature and breathtaking landscapes.",
                    places: [
                        "National Palace of Sintra",
                        "Chalet Biester",
                        "Pena Palace",
                        "Valley of the Lakes",
                        "Castle of the Moors",
                    ],
                },
                {
                    name: "Charms of the Sintra Coast",
                    tagline: "Where the ocean meets the cliffs",
                    description: "Explore two of the most beautiful landscapes on the Portuguese coast, where the ocean meets stunning cliffs and villages full of charm.",
                    places: ["Azenhas do Mar", "Praia das Maçãs"],
                },
                {
                    name: "Cabo da Roca",
                    tagline: "Where the Land Ends",
                    description: "Visit the westernmost point of continental Europe and enjoy one of the most spectacular views over the Atlantic Ocean.",
                    places: ["Cabo da Roca"],
                },
                {
                    name: "Cascais Premium Experience",
                    tagline: "Coastal charm & golden beaches",
                    description: "Discover the charm of Cascais and drive along one of the most beautiful coastal roads in Portugal, enjoying beaches, cliffs and unforgettable landscapes.",
                    places: [
                        "Cascais Old Town",
                        "Boca do Inferno",
                        "Praia do Guincho",
                    ],
                },
                {
                    name: "Faith, Sea & History",
                    tagline: "Spirituality and Portuguese tradition",
                    description: "A unique experience combining spirituality, tradition, Portuguese culture and one of the most beautiful medieval villages in the country.",
                    places: ["Fátima", "Nazaré", "Óbidos"],
                },
            ],
        },
        info: {
            eyebrow: "Important Information",
            title: "What's included in the tours",
            body: "Our tour prices exclusively include transportation and guidance throughout the entire tour. Tickets for monuments and tourist attractions are not included and must be purchased separately by the clients.",
            links_title: "Official ticket links",
            pena: "Pena Palace",
            regaleira: "Quinta da Regaleira",
        },
        gallery: {
            eyebrow: "Gallery",
            title: "Photographs of a Portuguese journey",
            intro: "Real moments from our destinations.",
        },
        diff: {
            eyebrow: "Why us",
            title: "Why choose CH TOURS",
            items: [
                "Vast market experience",
                "Private tours",
                "Personalized service",
                "Flexible itineraries",
                "Comfortable vehicle",
                "Experienced driver",
                "Safety",
                "Punctuality",
                "Service in Portuguese, English and Spanish",
            ],
        },
        reviews: {
            eyebrow: "Reviews",
            title: "What our travelers say",
            intro: "Real stories from those who've experienced Portugal with us.",
            average: "average rating",
            total_reviews: "reviews",
            based_on: "based on",
            leave: "Leave a review",
            share: "Share your experience",
            form_hint: "Share your experience with us. Your review will appear on the site once submitted.",
            name_label: "Name",
            country_label: "Country",
            tour_label: "Tour taken",
            tour_placeholder: "Select a tour (optional)",
            rating_label: "Rating",
            message_label: "Message",
            submit: "Submit review",
            submitting: "Submitting…",
            success: "Thank you! Your review has been published.",
            error: "Could not submit. Please try again.",
            close: "Close",
            required: "Required field",
            no_reviews: "No reviews yet. Be the first!",
            select_rating: "Select a rating",
        },
        contact: {
            eyebrow: "Contact",
            title: "Let's plan your next adventure",
            intro: "Reach out directly via WhatsApp or send us your message — we reply quickly.",
            whatsapp_big: "Chat on WhatsApp",
            name: "Name",
            email: "Email",
            phone: "Phone",
            message: "Message",
            send: "Send via WhatsApp",
            email_label: "Email",
            address_label: "Address",
            address_value: "Rua do Cabeço, nº 7 — Sintra, Portugal",
            form_hint: "On submit you will be redirected to WhatsApp with your message.",
        },
        footer: {
            tagline: "Private tours in Portugal",
            slogan: "\"We turn every tour into a unique experience.\"",
            rights: "All rights reserved.",
            navigation: "Navigation",
            follow: "Social Media",
        },
        misc: {
            back_to_top: "Back to top",
            whatsapp_float: "Talk to us",
            language: "Language",
        },
    },

    es: {
        nav: {
            home: "Inicio",
            about: "Nosotros",
            tours: "Tours",
            gallery: "Galería",
            contact: "Contacto",
            book: "Reservar",
        },
        hero: {
            title: "CH TOURS",
            subtitle: "Descubre Portugal con comodidad, seguridad y una experiencia personalizada.",
            cta_whatsapp: "Reservar por WhatsApp",
            cta_tours: "Conoce los Tours",
            scroll: "Desliza hacia abajo",
        },
        trust: {
            private: "Tours Privados",
            personal: "Atención Personalizada",
            driver: "Chofer Experimentado",
            comfort: "Comodidad",
            safety: "Seguridad",
            flexibility: "Flexibilidad",
        },
        about: {
            eyebrow: "Sobre nosotros",
            title: "Bienvenido a CH TOURS",
            p1: "En CH TOURS contamos con una vasta experiencia en el mercado turístico de Portugal, ofreciendo tours privados pensados para brindar comodidad, tranquilidad y experiencias inolvidables.",
            p2: "Cada tour se realiza de acuerdo con el deseo de cada cliente, respetando su tiempo, intereses y preferencias.",
            p3: "Nuestro objetivo es ofrecer una atención personalizada, permitiendo que cada visitante conozca Portugal de forma exclusiva, cómoda y segura.",
            p4: "Trabajamos con profesionalismo, puntualidad, calidad y dedicación para convertir cada tour en una experiencia memorable.",
            stat1: "Años de experiencia",
            stat2: "Tours realizados",
            stat3: "Idiomas",
        },
        tours: {
            eyebrow: "Nuestros Tours",
            title: "Itinerarios Exclusivos por Portugal",
            intro: "Cada tour es totalmente personalizado. Elige el que más te guste y reserva directamente por WhatsApp.",
            visited: "Lugares visitados",
            book: "Reservar por WhatsApp",
            see_more: "Ver más fotos",
            close: "Cerrar",
            photos_of: "Fotografías del tour",
            items: [
                {
                    name: "Sintra Imperial",
                    tagline: "El Tour Más Completo",
                    description: "Descubre los monumentos más emblemáticos de Sintra en un tour inolvidable que combina historia, arquitectura, naturaleza y paisajes deslumbrantes.",
                    places: [
                        "Palacio Nacional de Sintra",
                        "Chalet Biester",
                        "Palacio da Pena",
                        "Valle de los Lagos",
                        "Castillo de los Moros",
                    ],
                },
                {
                    name: "Encantos de la Costa de Sintra",
                    tagline: "Donde el océano se encuentra con los acantilados",
                    description: "Conoce dos de los paisajes más hermosos de la costa portuguesa, donde el océano se encuentra con acantilados impresionantes y pueblos llenos de encanto.",
                    places: ["Azenhas do Mar", "Praia das Maçãs"],
                },
                {
                    name: "Cabo da Roca",
                    tagline: "Donde termina la Tierra",
                    description: "Visita el punto más occidental de Europa Continental y admira una de las vistas más espectaculares sobre el Océano Atlántico.",
                    places: ["Cabo da Roca"],
                },
                {
                    name: "Cascais Premium Experience",
                    tagline: "Encanto costero y playas doradas",
                    description: "Descubre el encanto de Cascais y recorre una de las carreteras costeras más bellas de Portugal, disfrutando de playas, acantilados y paisajes inolvidables.",
                    places: [
                        "Cascais Villa",
                        "Boca do Inferno",
                        "Praia do Guincho",
                    ],
                },
                {
                    name: "Fe, Mar e Historia",
                    tagline: "Espiritualidad y tradición portuguesa",
                    description: "Una experiencia única que reúne espiritualidad, tradición, cultura portuguesa y uno de los pueblos medievales más bonitos del país.",
                    places: ["Fátima", "Nazaré", "Óbidos"],
                },
            ],
        },
        info: {
            eyebrow: "Información Importante",
            title: "Qué está incluido en los tours",
            body: "Los precios de nuestros tours incluyen exclusivamente el transporte y el acompañamiento durante todo el recorrido. Las entradas para monumentos y atracciones turísticas no están incluidas y deben ser adquiridas por los clientes.",
            links_title: "Enlaces oficiales para comprar entradas",
            pena: "Palacio da Pena",
            regaleira: "Quinta da Regaleira",
        },
        gallery: {
            eyebrow: "Galería",
            title: "Fotografías de un viaje por Portugal",
            intro: "Momentos reales de nuestros destinos.",
        },
        diff: {
            eyebrow: "Diferenciales",
            title: "Por qué elegir CH TOURS",
            items: [
                "Amplia experiencia en el mercado",
                "Tours privados",
                "Atención personalizada",
                "Flexibilidad en la ruta",
                "Vehículo cómodo",
                "Chofer experimentado",
                "Seguridad",
                "Puntualidad",
                "Atención en portugués, inglés y español",
            ],
        },
        reviews: {
            eyebrow: "Reseñas",
            title: "Lo que dicen nuestros viajeros",
            intro: "Historias reales de quienes ya vivieron Portugal con nosotros.",
            average: "puntuación media",
            total_reviews: "reseñas",
            based_on: "basado en",
            leave: "Dejar una reseña",
            share: "Comparte tu experiencia",
            form_hint: "Comparte tu experiencia con nosotros. Tu reseña aparecerá en el sitio tras su envío.",
            name_label: "Nombre",
            country_label: "País",
            tour_label: "Tour realizado",
            tour_placeholder: "Selecciona un tour (opcional)",
            rating_label: "Puntuación",
            message_label: "Mensaje",
            submit: "Enviar reseña",
            submitting: "Enviando…",
            success: "¡Gracias! Tu reseña se ha publicado.",
            error: "No se pudo enviar. Inténtalo de nuevo.",
            close: "Cerrar",
            required: "Campo obligatorio",
            no_reviews: "Aún no hay reseñas. ¡Sé el primero!",
            select_rating: "Selecciona una puntuación",
        },
        contact: {
            eyebrow: "Contacto",
            title: "Planifiquemos tu próxima aventura",
            intro: "Contáctanos directamente por WhatsApp o envíanos tu mensaje — respondemos rápidamente.",
            whatsapp_big: "Hablar por WhatsApp",
            name: "Nombre",
            email: "Correo",
            phone: "Teléfono",
            message: "Mensaje",
            send: "Enviar por WhatsApp",
            email_label: "Correo",
            address_label: "Dirección",
            address_value: "Rua do Cabeço, nº 7 — Sintra, Portugal",
            form_hint: "Al enviar, serás redirigido a WhatsApp con tu mensaje.",
        },
        footer: {
            tagline: "Tours Privados en Portugal",
            slogan: "\"Convertimos cada tour en una experiencia única.\"",
            rights: "Todos los derechos reservados.",
            navigation: "Navegación",
            follow: "Redes Sociales",
        },
        misc: {
            back_to_top: "Volver arriba",
            whatsapp_float: "Habla con nosotros",
            language: "Idioma",
        },
    },
};

export const LANGUAGES = [
    { code: "pt", label: "Português", flag: "🇵🇹" },
    { code: "en", label: "English", flag: "🇬🇧" },
    { code: "es", label: "Español", flag: "🇪🇸" },
];
